import * as $ from 'jquery';
import 'slick-carousel';

class SpaceRecipe {
  private ProductCategoryCarouselElements: NodeListOf<HTMLElement> = null;

  init = () => {
    this.ProductCategoryCarouselElements = document.querySelectorAll(
      '.js-card-carousell'
    );
    if (!this.ProductCategoryCarouselElements) {
      return;
    }

    this.bindListeners();
  };

  private bindListeners() {
    Array.prototype.map.call(this.ProductCategoryCarouselElements, (element) => {
      this.handleSlickInit(element);
    });
  }

  handleSlickInit(el: MouseEvent) {
    const sliderLoop = !$(el).hasClass('js-card-carousell--no-loop');

    const $el = $(el);
    const slickSettings: JQuerySlickOptions = {
      dots: false,
      prevArrow: $(el).siblings('.slider-controls').find('.slick-prev'),
      nextArrow: $(el).siblings('.slider-controls').find('.slick-next'),
      variableWidth: true,
      adaptiveHeight: true,
      infinite: sliderLoop,
      slidesToScroll: 1
    };
    $el.slick(slickSettings);
  }
}

const SpaceRecipeInstance = new SpaceRecipe();
SpaceRecipeInstance.init();
export { SpaceRecipe, SpaceRecipeInstance };
